import { ValidationHelper } from '../../../../../helpers/validationHelpers';
// Default Base Map Layer (a base map that is specified only by its id name)
export class DefaultBaseMapLayer {
    constructor(id, isActive) {
        this.id = id;
        this.isActive = isActive;
        this.type = 'DefaultBaseMapLayer';
    }
    validate() {
        let valid = true;
        if (!ValidationHelper.existProperty(this.id)
            || !ValidationHelper.existProperty(this.type)
            || !ValidationHelper.existProperty(this.isActive)) {
            valid = false;
        }
        if (!ValidationHelper.sameTypeProperty(this.id, 'string')
            || this.type !== 'DefaultBaseMapLayer'
            || !ValidationHelper.sameTypeProperty(this.isActive, 'boolean')) {
            valid = false;
        }
        if (this.type !== 'DefaultBaseMapLayer') {
            valid = false;
        }
        if (!valid)
            throw new Error(`Default layer ${this.id} has an incorrect entering property`);
        return valid;
    }
}
//# sourceMappingURL=defaultBaseMapLayer.js.map